import { Col, Row } from "react-bootstrap";
import GoogleLogin from "./GoogleLogin";
// import FBLogin from "./FBLogin";
import LinkedInLogin from "./LinkedinLogin";
const GetLogin = ({ onLogin }) => {
    return (
        <GoogleLogin onLogin={onLogin} />
    )
}

export default GetLogin;